"use client"
import React, { useState, useEffect } from "react";

// toggles browser fullscreen for the element matching `selector`; hidden where fullscreen isn't allowed
// (e.g. iOS, or an iframe embedded without allowfullscreen). Sits in the locator header's filter row.
const LocatorFullscreenControl = ({ selector = "div.fullscreen-map" }) => {
  const [supported, setSupported] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return;
    setSupported(!!document.fullscreenEnabled);
    const onChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
      // let the map pick up its new size
      setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
    };
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const toggle = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    } else {
      document.querySelector(selector)?.requestFullscreen().catch(error => {
        console.log("Unable to enter fullscreen", error);
      });
    }
  };

  if (!supported) return null;

  return (
    <button
      type="button"
      className="btn btn-sm btn-secondary locator-fullscreen-control"
      onClick={toggle}
      title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
      aria-label={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
    >
      <i className={`fa-solid ${isFullscreen ? "fa-compress" : "fa-expand"}`}></i>
    </button>
  );
};

export default LocatorFullscreenControl;
